(() => {
  const root = document.querySelector('[data-casebang-pc2-root]');
  if (!root) return;

  const start = () => {
    const target = root.querySelector('#casebang-mockup-container');
    const preview = window.__casebangSelectorCriticalPreview;
    if (!target || target.dataset.casebangEarlyPreview === 'ready') return;

    target.dataset.casebangEarlyPreview = 'ready';

    let observer;
    let timeout;

    const release = () => {
      target.querySelector('.casebang-pc2-initial-preview')?.remove();
      target.removeAttribute('aria-busy');
      observer?.disconnect();
      window.clearTimeout(timeout);
    };

    const releaseWhenSelectorMounts = () => {
      if (!target.querySelector('.casebang-phone-preview-stage')) return false;
      release();
      return true;
    };

    observer = new MutationObserver(releaseWhenSelectorMounts);
    observer.observe(target, { childList: true, subtree: true });
    releaseWhenSelectorMounts();

    timeout = window.setTimeout(() => {
      target.removeAttribute('aria-busy');
      observer.disconnect();
    }, 15000);

    if (!preview || typeof preview.then !== 'function') {
      target.removeAttribute('aria-busy');
      return;
    }

    preview.then((image) => {
      if (!image || target.childElementCount > 0) return;

      const visual = document.createElement('div');
      visual.className = 'casebang-pc2-initial-preview';

      const element = document.createElement('img');
      element.src = image.src;
      element.srcset = image.srcset;
      element.sizes = image.sizes;
      element.alt = image.alt;
      element.width = 640;
      element.height = 640;
      element.loading = 'eager';
      element.fetchPriority = 'high';
      element.decoding = 'async';

      visual.appendChild(element);
      target.appendChild(visual);
    }).catch(release);

    window.addEventListener('pagehide', () => {
      observer.disconnect();
      window.clearTimeout(timeout);
    }, { once: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
